import { parseLatLon } from '../../airport/util/parseUtils';
/**
 * Airport autocomplete search result model
 */
var AirportAutocompleteResult = /** @class */ (function () {
    function AirportAutocompleteResult() {
    }
    Object.defineProperty(AirportAutocompleteResult.prototype, "identifier", {
        /**
         * Gets the identifier that should be displayed for this airport. This will either be the ICAO identifier if
         * available, or the FAA identifier otherwise.
         */
        get: function () {
            return this.icaoId || this.faaId || '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses an airport as returned by the API into an instance of the Airport class
     */
    AirportAutocompleteResult.parse = function (data) {
        return Object.assign(new AirportAutocompleteResult(), {
            airportId: data.airportId,
            icaoId: data.icaoId,
            faaId: data.faaId,
            name: data.name,
            location: data.location ? parseLatLon(data.location.latitude, data.location.longitude) : null,
            publicUse: this.parsePublicUse(data.airportUsage),
            city: data.city || null,
            stateProvince: data.stateProvince || null,
            country: data.country || null,
            sourceId: data.sourceId
        });
    };
    /**
     * Parses airport usage type from string
     * @param type {string} Airport usage type as returned by API
     * @return {boolean} Parsed airport usage type
     */
    AirportAutocompleteResult.parsePublicUse = function (type) {
        switch (type) {
            case 'public':
                return true;
            case 'private':
                return false;
            default:
                return null;
        }
    };
    return AirportAutocompleteResult;
}());
export { AirportAutocompleteResult };
